export default "__VITE_ASSET__9e86a7cc__"